package org.ksdfv.thelema.img

import org.ksdfv.thelema.data.IByteData
import org.ksdfv.thelema.gl.GL_RGBA
import org.ksdfv.thelema.gl.GL_UNSIGNED_BYTE

/** @author zeganstyl */
class ImageData(
    override var width: Int,
    override var height: Int,
    override var bytes: IByteData,
    override var glInternalFormat: Int = GL_RGBA,
    override var glPixelFormat: Int = GL_RGBA,
    override var glType: Int = GL_UNSIGNED_BYTE,
    override var uri: String = "",
    override var name: String = uri
): IImageData {
    override fun destroy() {}
}
